export const spaceChangeTranslations = {
  true: 'issues:common.spaceChangeRequested.true',
  false: 'issues:common.spaceChangeRequested.false',
} as const;
